// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { concat, find } from 'lodash'
import PropTypes from 'prop-types'
import { EMAR_FREQ_PRESETS } from '../../../../common/constants'
import Form from '../../../forms/Form'

const handleChange = (props) => {
  const { setFormField, value } = props

  const presetValue = find(EMAR_FREQ_PRESETS, { key: value })

  if (presetValue) {
    const { freqInterval, freqUnit } = presetValue
    setFormField({ key: 'freqInterval', value: freqInterval })
    setFormField({ key: 'freqUnit', value: freqUnit })
    setFormField({ key: 'freqDaysInWeek', value: null })
  }

  setFormField({ key: 'customFreq', value: true })
}

/**
@description Renders EmarFrequencyField for the Add Medication modal

@param {object} fields. The form fields.

@param {string} formId. addEmarMedication. Identifies the form.

@returns {function} EmarFrequencyField.
*/

export default function EmarFrequencyField(props) {
  const { fields, formId, readOnly, testId } = props

  if (fields.PRN) return null

  const form = concat(
    {
      ...END_DATE_FORM[0],
      handleChange: (value) => {
        if (!readOnly) handleChange({ ...props, value })
      },
      selectStyle: styles.selectField
    },
    END_DATE_FORM[1]
  )

  const style = {
    ...styles.container,
    ...(readOnly ? styles.readOnlyContainer : {})
  }

  return (
    <div
      style={style}
      data-testid={testId ? `${testId}-frequency-field` : 'frequency-field'}
    >
      <Form
        noLeftMargin
        formId={formId}
        fields={fields}
        form={form}
        readOnly={readOnly}
      />
    </div>
  )
}

EmarFrequencyField.propTypes = {
  fields: PropTypes.object.isRequired,
  formId: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  setFormField: PropTypes.func.isRequired,
  testId: PropTypes.string
}

const styles = {
  selectField: {
    width: 150
  },
  container: {
    background: colors.white,
    borderRadius: 15,
    marginTop: 16
  },
  readOnlyContainer: {
    opacity: 0.6,
    pointerEvents: 'none'
  }
}

const END_DATE_FORM = [
  {
    key: 'repeat',
    label: 'Frequency',
    note: 'How often does this medication need to be administered?',
    placeholder: 'Select...',
    type: 'antdSelect',
    values: [
      { value: 'everyDay', label: 'Every day' },
      { value: 'everyOtherDay', label: 'Every other day' },
      { value: 'everyThreeDays', label: 'Every 3 days' },
      { value: 'everyWeek', label: 'Every week' },
      { value: 'everyFourWeeks', label: 'Every 4 weeks' },
      { value: 'everyTwelveWeeks', label: 'Every 12 weeks' },
      { value: 'custom', label: 'Custom' }
    ]
  },
  {
    dependsOnKey: 'repeat',
    dependsOnValue: 'custom',
    key: 'customFreq',
    label: 'Custom',
    style: { marginRight: 0, marginTop: 0 },
    type: 'medicationFrequency'
  }
]
